import React from 'react';
const Maintenance: React.FC = () => {
  return (
    <div style={{ background: 'grey' }}>
      <div
        style={{
          background: 'url("/shapes-lines-large-clean.svg")',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#373737',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            left: '-270px',
            marginBottom: '100px'
          }}
        >
          <img src={`/logo-white.svg`} alt="smarterwx logo" />
          <p
            style={{
              fontSize: '32px',
              color: 'white',
              marginLeft: '20px'
            }}
          >
            We&rsquo;ll be back soon
          </p>
        </div>
        <div>
          <p
            style={{
              fontSize: '20px',
              color: '#4a90e2',
              marginBottom: '16px'
            }}
          >
            Under maintenance
          </p>
          <p
            style={{
              fontSize: '14px',
              color: 'white',
              marginBottom: '40px'
            }}
          >
            SmarterWX Locate is undergoing scheduled maintenance.
            <br />
            Please check back soon.
          </p>
          <a
            href="https://www.smarterwx.com/"
            style={{
              fontSize: '14px',
              color: '#4a90e2',
              textDecoration: 'none'
            }}
          >
            Find out more about SmarterWX
          </a>
        </div>
      </div>
    </div>
  );
};
export default React.memo(Maintenance);
